var _excluded = ["min", "max", "open", "onConfirm", "onClose", "triggerToken"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DatePicker as AntdMobileDatePicker } from 'antd-mobile';
import React from 'react';
var MobileDatePanel = function MobileDatePanel(props) {
  // const { value, onSelect, onHover, minDate, maxDate } = props;
  // const { value, min, max, open, onConfirm } = props;
  var min = props.min,
    max = props.max,
    open = props.open,
    _onConfirm = props.onConfirm,
    _onClose = props.onClose,
    triggerToken = props.triggerToken,
    restProps = _objectWithoutProperties(props, _excluded);

  // Value
  // const startDate = React.useMemo(() => dayjs().date(1).month(0), []);
  // const [innerValue, setInnerValue] = React.useState(value || startDate);
  var _React$useState = React.useState(open),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];

  // React.useEffect(() => {
  //   if (value) {
  //     setInnerValue(value);
  //   }
  //   // setVisible(true);
  // }, [value]);

  React.useEffect(function () {
    setVisible(open);
  }, [open, triggerToken]);

  // const getPrecision = (picker: PickerMode) => {
  //   return pickerMap.get(picker) as string;
  // };

  // Render
  return /*#__PURE__*/React.createElement(AntdMobileDatePicker, _extends({}, restProps, {
    destroyOnClose: true,
    visible: visible
    // onSelect={(nextValue) => {
    //   const nextDate = dayjs(nextValue);
    //   setInnerValue(dayjs(nextDate));
    //   // onHover?.(nextDate);
    // }}
    ,
    onConfirm: function onConfirm(nextDate) {
      if (_onConfirm) {
        _onConfirm(nextDate);
      }
      setVisible(false);
    },
    onClose: function onClose() {
      if (_onClose) {
        _onClose();
      }
      setVisible(false);
    },
    max: max,
    min: min
  }));
};
export default MobileDatePanel;